"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/testSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, ReactNode } from "react";

export type HomeTwelveTestSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Have Questions About Your Test?" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Get to know the skilled professionals who bring experience, dedication, and compassionate care." */
    sectionDiv0Div0P0PText?: ReactNode;
    /** Default: "callto:" */
    sectionDiv0Div1Div0Div1Link0LinkHref?: string;
    /** Default: "+1 24565 89856" */
    sectionDiv0Div1Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div1Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div1Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "#" */
    sectionDiv0Div1Link0LinkHref?: string;
    sectionDiv0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Test Now" */
    sectionDiv0Div1Link0Span1SpanText?: ReactNode;
    /** Default: "shape" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/test-img-shape.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shape" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/test-img-shape.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
};

const HomeTwelveTestSectionGenerated: FC<HomeTwelveTestSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Have Questions About Your Test?",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Get to know the skilled professionals who bring experience, dedication, and compassionate care.",
    sectionDiv0Div1Div0Div1Link0LinkHref = "callto:",
    sectionDiv0Div1Div0Div1Link0LinkText = "+1 24565 89856",
    sectionDiv0Div1Div0Div1Link0LinkVisible,
    sectionDiv0Div1Div0Div1Link0LinkRenderer,
    sectionDiv0Div1Div0Div1Link0LinkProps,
    sectionDiv0Div1Link0LinkHref = "#",
    sectionDiv0Div1Link0LinkVisible,
    sectionDiv0Div1Link0LinkRenderer,
    sectionDiv0Div1Link0LinkProps,
    sectionDiv0Div1Link0Span1SpanText = "Book Test Now",
    sectionImageWithBasePath0ImageAlt = "shape",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/test-img-shape.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "shape",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/test-img-shape.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
}) => {
    return (
        <section className="test-section-twelve section bg-primary">
            <div className="container">
                <div className="section-header section-header-twelve text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-white" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            {" "}
                        </h2>
                    ))}
                    <p className="description text-white">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className="support-container">
                    <div className="support-item-list">
                        <div className="support-item-icon">
                            <i className="isax isax-call" />
                        </div>
                        <div className="support-item-content">
                            {renderNode(sectionDiv0Div1Div0Div1Link0LinkVisible, sectionDiv0Div1Div0Div1Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div1Div0Div1Link0LinkHref} className="link" {...(sectionDiv0Div1Div0Div1Link0LinkProps ?? {})}>{sectionDiv0Div1Div0Div1Link0LinkText}</SmartLink>
                            ))}
                        </div>
                    </div>
                    {renderNode(sectionDiv0Div1Link0LinkVisible, sectionDiv0Div1Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div1Link0LinkHref} className="btn btn-primary theme-11-btn" {...(sectionDiv0Div1Link0LinkProps ?? {})}>
                            <span className="icon one">
                                <i className="isax isax-arrow-right-1" />
                                {" "}
                            </span>
                            <span className="content">{sectionDiv0Div1Link0Span1SpanText}</span>
                            <span className="icon two">
                                <i className="isax isax-arrow-right-1" />
                                {" "}
                            </span>
                        </SmartLink>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid test-shape-img" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid test-shape-img-2" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTwelveTestSectionGenerated;
